import { render } from "./TasksOverdueListView.vue?vue&type=template&id=278fc91f"
import script from "./TasksOverdueListView.vue?vue&type=script&lang=js"
export * from "./TasksOverdueListView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__